import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import CustomTooltip from '../../../../../../componentLibrary/CustomTooltip';
import * as Styled from './styles';
import handleKeyPress from '../../../../../../common/handleKeyPress';

const toolTipTags = {
    IMAGE: { name: 'Image', position: 'top' },
    PARAGRAPH: { name: 'Text', position: 'top' },
    BUTTON: { name: 'Button', position: 'top' },
    SPACER: { name: 'Spacer', position: 'bottom' },
    SOCIAL: { name: 'Social Links', position: 'bottom' },
    SURVEY: { name: 'Survey', position: 'top' },
    VIDEO: { name: 'Video', position: 'bottom' },
};

const ElementIcon = ({ element, borderColor, onClick, isEnabled }) => (
    <Styled.IconDiv
        element={element}
        borderColor={borderColor}
        data-tip
        onClick={isEnabled ? onClick : null}
        onKeyDown={(e) => (isEnabled ? handleKeyPress(e, () => onClick(e)) : null)}
        tabIndex="0"
        data-for={`${element}-icon`}
        isEnabled={isEnabled}
        role="button"
        aria-label={`Add ${toolTipTags[element].name} element to canvas`}
    >
        {isEnabled ? (
            <ReactTooltip
                id={`${element}-icon`}
                place={toolTipTags[element].position}
                effect="solid"
                style={{ width: 20 }}
            >
                <Styled.TooltipSpan>{toolTipTags[element].name}</Styled.TooltipSpan>
            </ReactTooltip>
        ) : (
            <CustomTooltip
                dataRef={`${element}-icon`}
                offset={{ top: 8 }}
                text={`Request a full product demo to see the ${toolTipTags[element].name} Element.`}
            />
        )}
    </Styled.IconDiv>
);

ElementIcon.defaultProps = {
    isEnabled: true,
};

ElementIcon.propTypes = {
    element: PropTypes.string.isRequired,
    borderColor: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool,
};

export default ElementIcon;
